import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";

import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
  AiOutlineContacts,
  AiOutlineBars,
} from "react-icons/ai";



// import { CgFileDocument } from "react-icons/cg";

function NavBar({tech,home,about,contact,project}) {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  // console.log(navColour,"navColour")

  const scrollhome =()=>{
    

    home.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    })
  }

  const scrollAbout =()=>{
    

    about.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    })
  }
  const scrollTech =()=>{
    

    tech.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    })
  }

  const scrollProject =()=>{
    

    project.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    })
  }


  const scrollContact =()=>{
    

    contact.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    })
  }


  

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navba"}
      // className="navba"
    >
      <Container>
        <Navbar.Brand target="_blank">
        Altaf Ali Baig
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto" defaultActiveKey="#home">
            <Nav.Item  >
              <Nav.Link as={Link} to="" onClick={() => {updateExpanded(false);
                 scrollhome();
              }}>
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to=""
                onClick={() => {
                  updateExpanded(false);
                  scrollAbout();
                }}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to=""
                onClick={() => {
                  updateExpanded(false);
                  scrollTech();
                }}
              >
                <AiOutlineBars style={{ marginBottom: "2px" }} /> Tech-Stack
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to=""
                onClick={() => {updateExpanded(false);
                  scrollProject();}}
              >
                <AiOutlineFundProjectionScreen
                  style={{ marginBottom: "2px" }}
                />{" "}
                Projects
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to=""
                onClick={() => {updateExpanded(false);
                  scrollContact();}}
              >
                <AiOutlineContacts style={{ marginBottom: "2px" }} /> Contact
              </Nav.Link>
            </Nav.Item>

            
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
